// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"516":"847587d6","943":"847587d6"}[chunkId] + ".chunk.css";
};